import React from "react";

import Fade from "@material-ui/core/Fade";

import "./styles.scss";
import { maskPhone } from "../../../../Utils/masks";

const CamposAssuntoDescricaoContato = ({
  setAssunto,
  assunto,
  setDescricao,
  descricao,
  contato,
  setContato,
  tipoAtendimentoSolicitacao,
  tiposSolicitacaoComAgendamento,
  isSindico,
}) => {
  // antiga linha 39: !tiposSolicitacaoComAgendamento.includes(tipoAtendimentoSolicitacao)

  return (
    <>
      <Fade in>
        <div className="novaSolicitacao__assunto">
          <label>Assunto</label>
          <textarea
            type="text"
            wrap="soft"
            className="centralized"
            placeholder="Dê um título a sua solicitação, destacando apenas um tópico de grande significância..."
            maxLength="255"
            onChange={(e) => {
              setAssunto(e.target.value);
            }}
            id="txtAreaAssunto"
          />
          <label className="novaSolicitacao__assunto__obrigatorio">
            Campo opcional - {255 - assunto?.length} / 255
          </label>
        </div>
      </Fade>

      {tipoAtendimentoSolicitacao !== "Assistência Técnica" && (
        <Fade in>
          <div className="novaSolicitacao__descricao">
            <label>Descrição</label>
            <div className="novaSolicitacao__descricao__text">
              <textarea
                type="text"
                wrap="soft"
                maxLength="2000"
                placeholder="Para dar andamento na sua solicitação de forma assertiva, descreva da melhor forma os pontos principais da sua questão."
                onChange={(e) => {
                  setDescricao(e.target.value);
                }}
                id="txtAreaDescricao"
              />
            </div>
            <label className="novaSolicitacao__descricao__obrigatorio">
              Campo obrigatório - {2000 - descricao?.length} / 2000
            </label>
          </div>
        </Fade>
      )}

      {isSindico && (
        // campo contato sindico
        <Fade in>
          <div className="novaSolicitacao__contato">
            <label>Contato</label>
            <textarea
              type="text"
              wrap="soft"
              className="centralized"
              placeholder="(DDD) + Telefone"
              value={contato}
              onChange={(e) => {
                setContato(maskPhone(e.target.value));
              }}
              id="txtAreaContato"
              style={{ width: 160 }}
            />
            <label className="novaSolicitacao__contato__obrigatorio">
              Campo obrigatório*
            </label>
          </div>
        </Fade>
      )}

      {!tiposSolicitacaoComAgendamento.includes(tipoAtendimentoSolicitacao) && (
        <p className="alertMessage">
          *Você deve descrever detalhadamente sua solicitação utilizando os
          campos assunto e descrição para resolver sua solicitação rapidamente.
        </p>
      )}
    </>
  );
};

export default CamposAssuntoDescricaoContato;
